import PropTypes from 'prop-types'
import { connect } from 'react-redux'

import { useStaleClientReload } from '@/hooks'

import { selectUserRole, selectUserDataUniqId } from '../reducers/userDataReducer'
import { selectActiveBuilding } from '../reducers/buildingSelectorReducer'
import {
  dispatchAddUnreadConversationIds,
  dispatchRemoveFromUnreadConversationIds,
  dispatchUpdateConversation,
  dispatchAddConversation,
  selectChatContacts,
} from '../reducers/chatReducer'
import API from '../api/api'

import useChatListenerUnreads from './Chat/useChatListenerUnreads'
import useChatListenerMessages from './Chat/useChatListenerMessages'
import { convertConversation } from './Chat/helpers'

const GlobalListeners = ({
  userRole,
  userUniqId,
  userBuildingId,
  chatContacts,
  dispatchAddUnreadConversationIds,
  dispatchRemoveFromUnreadConversationIds,
  dispatchUpdateConversation,
  dispatchAddConversation,
}) => {
  const enrichNewConversation = async (channelData) => {
    try {
      const { clientId } = channelData
      if (clientId) {
        const { data = [] } = await API.getChatClients([clientId])
        if (data.length) {
          const newConversation = convertConversation([channelData], {
            chatContacts,
            personsData: data,
          })
          dispatchAddConversation(newConversation[0])
        }
      }
    } catch (error) {
      console.error('Enrich new conversation error: ', error)
    }
  }

  useChatListenerUnreads({
    userRole,
    userUniqId,
    userBuildingId,
    dispatchAddUnreadConversationIds,
    dispatchRemoveFromUnreadConversationIds,
  })

  useChatListenerMessages({
    userRole,
    userUniqId,
    userBuildingId,
    dispatchUpdateConversation,
    dispatchAddConversation: enrichNewConversation,
  })

  useStaleClientReload()

  return <></>
}

GlobalListeners.propTypes = {
  children: PropTypes.element,
  userRole: PropTypes.string,
  userUniqId: PropTypes.number,
  userBuildingId: PropTypes.number,
  chatContacts: PropTypes.array,
  dispatchRemoveFromUnreadConversationIds: PropTypes.func,
  dispatchAddUnreadConversationIds: PropTypes.func,
  dispatchAddClosedConversationIds: PropTypes.func,
  dispatchRemoveClosedConversationIds: PropTypes.func,
  dispatchUpdateConversation: PropTypes.func,
  dispatchAddConversation: PropTypes.func,
}

export default connect(
  (state) => {
    const selectedBuilding = selectActiveBuilding(state)
    return {
      userRole: selectUserRole(state),
      userUniqId: selectUserDataUniqId(state),
      userBuildingId: selectedBuilding ? selectedBuilding.id : null,
      chatContacts: selectChatContacts(state),
    }
  },
  {
    dispatchAddUnreadConversationIds,
    dispatchRemoveFromUnreadConversationIds,
    dispatchUpdateConversation,
    dispatchAddConversation,
  },
)(GlobalListeners)
